import React from "react";
import { Upload, message } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";

const { Dragger } = Upload;

const UploadList = () => {
  const lang_choiced = useSelector((state) => state.lang_change);

  const props = {
    name: "file",
    multiple: false,
    accept: ".xlsx",
    action: "https://www.mocky.io/v2/5cc8019d300000980a055e76",
    onChange(info) {
      const { status } = info.file;
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        message.success(`  ${info.file.name} is uploaded succesfully!`);
      } else if (status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    progress: {
      strokeColor: {
        "0%": "#108ee9",
        "100%": "#87d068",
      },
      strokeWidth: 3,
      format: (percent) => `${parseFloat(percent.toFixed(2))}%`,
    },
  };
  return (
    <Dragger {...props}>
      <p className="ant-upload-drag-icon">
        <InboxOutlined />
      </p>
      <p className="ant-upload-text">
        {lang_choiced.pages.add_system.tabs.fileUpload.uploadTipText}
      </p>
      <p className="ant-upload-hint">
      {lang_choiced.pages.add_system.tabs.fileUpload.fileFormatTipText}
      </p>
    </Dragger>
  );
};

export default UploadList;
